
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-16">
            <h1 tabindex="1000" class="medium">Final Review and Confirmation</h1>
            <br />
        </div>
    </div>
    <!--<button #focusableEleTop class="focusable-element"></button>-->
    <div class="row" *ngIf="hasError" aria-live="polite" tabindex="0" role="alert">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul role="list">
                    <li role="listitem" *ngFor="let error of ErrorMessages" aria-atomic="true">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p>
                <strong> Selected Plan : {{enrollment.PLANTYPENAME}}</strong>
                <br /><br />
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <h5 class="bold-font">Please Read and Sign Below:</h5>
            <br />
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    <br />
                    <u>By completing this enrollment application, I agree to the following:</u>
                </p>
                <p>{{orgName}} is a Medicare drug plan and has a contract with the Federal government. I understand that this prescription drug coverage is in addition to my coverage under Medicare; therefore, I will need to keep my Medicare Part A or Part B coverage. It is my responsibility to inform {{orgName}} of any prescription drug coverage that I have or may get in the future. I can only be in one Medicare prescription drug plan at a time – if I am currently in a Medicare Prescription Drug Plan, my enrollment in {{orgName}} will end that enrollment. Enrollment in this plan is generally for the entire year. Once I enroll, I understand that I may only leave this plan or make changes during the Annual Enrollment Period (October 15 – December 7 each year), unless I qualify for a special enrollment period sooner under certain special circumstances allowed by CMS.</p>
                <p>
                    {{orgName}} serves a specific service area. If I move out of the area that {{orgName}} serves, I need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I must use network pharmacies except in an emergency when I cannot reasonably use {{orgName}} network pharmacies. Once I am a member of {{orgName}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read the Evidence of Coverage document from {{orgName}} when I get it to know which rules I must follow to get coverage.
                </p>
                <p>I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment penalty in addition to my premium for Medicare prescription drug coverage in the future.</p>
                <p>I understand that if I am getting assistance from a sales agent, broker, or other individual employed by or contracted with {{orgName}}, he/she may be paid based on my enrollment in {{orgName}}.</p>
                <p>Counseling services may be available in my state to provide advice concerning Medicare supplement insurance or other Medicare Advantage or Prescription Drug Plan options,medical assistance through the state Medicaid program and the Medicare Savings Program.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <br /><br />
            <h5 class="bold-font">Release of Information:</h5>
            <br /><br />
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    By joining this Medicare prescription drug plan, I acknowledge that {{orgName}} will release my information to Medicare and other plans as is necessary for treatment, payment and health care operations. I also acknowledge that {{orgName}} will release my information, including my prescription drug event data, to Medicare, who may release it for research and other purposes which follow all applicable Federal statutes and regulations. The information on this enrollment form is correct to the best of my knowledge. I understand that if I intentionally provide false information on this form, I will be disenrolled from the plan.
                </p>
                <p>I understand that my signature (or the signature of the person authorized to act on my behalf under State law where I live) on this application means that I have read and understand the contents of this application. If signed by an authorized individual (as described above), this signature certifies that: 1) this person is authorized under State law to complete this enrollment and 2) documentation of this authority is available upon request by Medicare.</p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <div class="bottom-20">
                Signature: {{EnrolleeSign}}
            </div>
        </div>
        <div class="col-16">
            <div class="bottom-20">

                <label class="option">
                    <ValidatedCheckbox [id]="'beneficiary-has-signed-application'"
                                       [label]="'Beneficiary has signed application'"
                                       [checked]="enrollment.APPSIGNEDIND"
                                       (onValueChange)="enrollment.APPSIGNEDIND= $event">
                    </ValidatedCheckbox>
                </label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p>Today's Date:{{CurrentDate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'If you are the authorized representative, you must sign below and provide the following information:'"
                                           [options]="rblAuthorizedRep"
                                           [selectedValue]="enrollment.AUTHREPIND"
                                           (onValueChange)="rblAuthorizedRepClick($event)"
                                           [radioGroupName]="'rblAuthorizedRep'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div *ngIf="isAuthRep">
        <fieldset>
            <legend>If you are the authorized representative, you must sign below and provide the following information</legend>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Name of authorized rep'"
                                            [id]="'auth-rep-name'"
                                            [text]="enrollment.AUTHREPNAME"
                                            (onValueChange)="enrollment.AUTHREPNAME = $event"
                                            [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <!--<ValidatedTextField [label]="'Phone Number '"
                                            [text]="enrollment.AUTHREPPHONE"
                                            [maxlength]="10"
                                            (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                            [validators]="[numericTextFieldValidator,lengthValidator]">
                        </ValidatedTextField>-->

                        <MaskedValidatedTextField class="field" [label]="'Phone Number of authorized rep'"
                                                  [text]="enrollment.AUTHREPPHONE"
                                                  (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                                  [maxlength]="10" [inputMask]="phoneNumberInputMask"
                                                  [for]="'AUTHREPPHONE'">
                        </MaskedValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="input-wrapper wide">
                        <ValidatedDropDown [label]="'Relationship to Enrollee'"
                                           [for]="'auth-rep-relationship'"
                                           [text]="enrollment.AUTHREPREL"
                                           [disabled]="'false'"
                                           [selectedValue]="enrollment.AUTHREPREL"
                                           (onValueChange)="enrollment.AUTHREPREL =$event"
                                           [options]="rblRelation">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Address of authorized rep'"
                                            [id]="'auth-rep-address'"
                                            [text]="enrollment.AUTHREPADD1"
                                            (onValueChange)="enrollment.AUTHREPADD1 = $event"
                                            [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'City'"
                                            [id]="'auth-rep-city'"
                                            [text]="enrollment.AUTHREPCITY"
                                            (onValueChange)="enrollment.AUTHREPCITY = $event"
                                            [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-4">
                    <div class="input-wrapper wide">
                        <ValidatedDropDown [selectedValue]="enrollment.AUTHREPST"
                                           [id]="'auth-rep-state'"
                                           [text]="enrollment.AUTHREPST"
                                           [label]="'State'"
                                           [disabled]="'false'"
                                           (onValueChange)="enrollment.AUTHREPST  = $event"
                                           [options]="states"
                                           (blur)="onBlur()"
                                           [for]="'AUTHREPST'">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-4">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Zip'"
                                            [id]="'auth-rep-zip'"
                                            [text]="enrollment.AUTHREPZIP"
                                            (onValueChange)="enrollment.AUTHREPZIP = $event"
                                            [validators]="[notBlankValidator]" [maxlength]="5">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="bottom-20">
                        <ValidatedTextField [label]="'Email of authorized rep (optional)'"
                                            [id]="auth-rep-email"
                                            [text]="enrollment.AUTHREPEMAIL"
                                            (onValueChange)="enrollment.AUTHREPEMAIL = $event"
                                            [validators]="[]">
                        </ValidatedTextField>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-24">
                    <div class="bottom-20">
                        <ValidatedCheckbox [id]="'cbxPOASignature'"
                                           [label]="'Power of Attorney has signed application'"
                                           [checked]="enrollment.AUTHREPSIGNEDIND"
                                           (onValueChange)="enrollment.AUTHREPSIGNEDIND= $event">
                        </ValidatedCheckbox>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
    <indvrep [enrollmentindvrepViewModel]="enrollment"></indvrep>
    <div class="row">
        <div class="col-24">
            <div *ngIf="showTermsButton">
                <button class="button primary" (click)="formSubmit()">The Applicant has read and agrees to the Terms of Enrollment</button>
            </div>



        </div>
    </div>
    <div class="side-by-side">
        <div> <button class="button primary" (click)="incompleteClick()">Save As Incomplete Enrollment</button></div>
        <div><button class="button cancel" (click)="goBack()">Go Back and Make Changes</button></div>
    </div>
</div>
